var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    location,
    price,
    loan_amount,
    purpose,
    down_payment,
    loan_types,
    points,
    credit
  } = options;

__p+='\n\n<!-- search description -->\n<span>Based on:</span><br>\n';
 if (purpose === "purchase") { 
__p+='\n<p class=\'description\'>'+
((__t=( location ))==null?'':__t)+
',  '+
((__t=( loan_amount ))==null?'':__t)+
' '+
((__t=( purpose ))==null?'':__t)+
' loan, '+
((__t=( down_payment ))==null?'':__t)+
'% down, '+
((__t=( credit ))==null?'':__t)+
' credit, '+
((__t=( loan_types ))==null?'':__t)+
', '+
((__t=( points ))==null?'':__t)+
' </p>\n';
 } else { 
__p+='\n<p class=\'description\'>'+
((__t=( location ))==null?'':__t)+
', '+
((__t=( loan_amount ))==null?'':__t)+
'  '+
((__t=( purpose ))==null?'':__t)+
' loan, '+
((__t=( price ))==null?'':__t)+
' est. value, '+
((__t=( credit ))==null?'':__t)+
' credit, '+
((__t=( loan_types ))==null?'':__t)+
', '+
((__t=( points ))==null?'':__t)+
' </p>\n';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/mortgage/rate_table_search_description.jst.ejs